import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  inset: 8px;
  z-index: 900;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  border: 2px dashed #0082ed;
  border-radius: 8px;
  background-color: rgba(20, 31, 44, 0.78);
  box-shadow: inset 0 0 0 1px rgba(0, 130, 237, 0.2);
`;
Wrapper.displayName = 'Wrapper';

export const Content = styled.div`
  width: min(520px, calc(100% - 48px));
  min-height: 210px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 6px;
  background-color: rgba(20, 31, 44, 0.44);
`;
Content.displayName = 'Content';

export const IconWrapper = styled.div`
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0082ed;

  svg {
    width: 46px;
    height: 46px;
  }
`;
IconWrapper.displayName = 'IconWrapper';

export const Text = styled.div`
  color: #dbeafe;
  font-size: 20px;
  font-weight: 600;
`;
Text.displayName = 'Text';

export const SubText = styled.div`
  color: #cbd5e1;
  font-size: 14px;
`;
SubText.displayName = 'SubText';
